import { Brain, BookOpen, LineChart, ShieldCheck, Rocket } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const steps = [
  {
    icon: Brain,
    step: "Step 1",
    title: "Learn",
    body: "Master the mindset, psychology and fundamentals of professional trading.",
  },
  {
    icon: BookOpen,
    step: "Step 2",
    title: "Practice",
    body: "Apply what you learn with guided homework, journaling and live mentoring.",
  },
  {
    icon: LineChart,
    step: "Step 3",
    title: "Trade",
    body: "Execute real setups with confidence and a disciplined risk management plan.",
  },
  {
    icon: ShieldCheck,
    step: "Step 4",
    title: "Become Consistent",
    body: "Turn scattered results into a repeatable standard, session after session.",
  },
  {
    icon: Rocket,
    step: "Step 5",
    title: "Prepare for Funding",
    body: "Build the track record and habits to trade funded accounts as a professional.",
  },
];

export default function Roadmap() {
  return (
    <section
      id="roadmap"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="roadmap-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <Reveal>
          <SectionLabel>The Roadmap</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            A clear path to consistency.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-4 text-sm text-zinc-500 font-light max-w-xl">
            Every trader we mentor follows the same proven journey, one step at a time.
          </p>
        </Reveal>

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute top-9 left-0 right-0 h-px bg-gradient-to-r from-[#6ea8ff]/50 via-white/15 to-white/5" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <Reveal key={s.title} delay={i * 0.1}>
                  <div className="relative" data-testid={`roadmap-step-${i}`}>
                    <div className="h-[72px] w-[72px] rounded-full flex items-center justify-center border border-[#6ea8ff]/40 bg-[#0A0A0A]">
                      <Icon strokeWidth={1} className="h-7 w-7 text-[#9fd3ff]" />
                    </div>
                    <div className="mt-6 section-label text-[9px] text-zinc-600">{s.step}</div>
                    <h3 className="mt-2 font-heading text-2xl font-light">{s.title}</h3>
                    <p className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">{s.body}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
